import { PropsWithChildren } from "react";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { ModalProvider } from "@ludens-reklame/react-modal";
import defaultTheme, { mobileBreakPointCSS } from "../defaults/theme.js";

const GlobalStyle = createGlobalStyle`
  :root {
    --primary-gradient-blob: color-mix(in srgb, var(--swatch1) 30%, white);
    --secondary-gradient-blob: color-mix(in srgb, var(--swatch2) 30%, white);
  }

  body {
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    background-color: #ffffff;
    color: var(--swatch2);
  }

  .section {
    background-color: #fff;
    color: var(--swatch2);
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: ${(props) => props.theme.spacing.s} 0;

    @media (min-width: ${mobileBreakPointCSS}) {
      margin: ${(props) => props.theme.spacing.m} 0;
    }
  }

  input,
  select {
    appearance: none;
    background-color: transparent;
    border: 1px solid var(--swatch2);
    padding: ${(props) => `${props.theme.spacing.xs} ${props.theme.spacing.s}`};
    border-radius: 10px;
    margin: 0;
    width: auto;
    font-family: inherit;
    font-size: inherit;
    cursor: inherit;
    line-height: inherit;
  }

  input {
    padding: ${(props) => `${props.theme.spacing.xs} ${props.theme.spacing.m}`};
  }

  select {
    background-image: url('data:image/svg+xml,<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.29883 8.88279C7.13141 8.88279 6.96902 8.85226 6.81165 8.79119C6.65428 8.73012 6.5237 8.6487 6.4199 8.54692L0.644119 2.92861C0.413925 2.70469 0.298828 2.4197 0.298828 2.07365C0.298828 1.72759 0.413925 1.44261 0.644119 1.21869C0.874313 0.994771 1.16729 0.882812 1.52304 0.882812C1.8788 0.882812 2.17177 0.994771 2.40197 1.21869L7.29883 5.98204L12.1957 1.21869C12.4259 0.994771 12.7189 0.882812 13.0746 0.882812C13.4304 0.882812 13.7233 0.994771 13.9535 1.21869C14.1837 1.44261 14.2988 1.72759 14.2988 2.07365C14.2988 2.4197 14.1837 2.70469 13.9535 2.92861L8.17775 8.54692C8.05219 8.66905 7.91617 8.75577 7.76968 8.80707C7.62319 8.85837 7.46624 8.88361 7.29883 8.88279Z" fill="%235F6B77"/></svg>');
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 1em;
  }

  .hidden {
    height: 1px;
    overflow: hidden;
    width: 1px;
    position: absolute;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%); /* browsers in the future */
    white-space: nowrap;
  }

  .mobile {
    @media (min-width: ${mobileBreakPointCSS}) {
      display: none!important;
    }
  }

  .mobile-menu-open {
    @media (max-width: ${mobileBreakPointCSS}) {
      overflow: hidden;
    }
  }

  .desktop {
    @media (max-width: ${mobileBreakPointCSS}) {
      display: none!important;
    }
  }

  svg {
    path {
      fill: var(--primary-icon-color);
    }

    line,
    .stroke {
      stroke: var(--swatch1);
    }
  }

  @keyframes FADE_IN {
      0% {
          opacity: 0;
      }
      50% {
          opacity: 0;
      }
      100% {
          opacity: 1;
      }
  }

  @keyframes FADE_IN_TOP {
      0% {
          transform: translateY(-100px);
          opacity: 0;
      }
      50% {
          opacity: 0;
      }
      100% {
          transform: translateY(0);
          opacity: 1;
      }
  }

  .modal-backdrop {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      animation: FADE_IN 0.24s ease-out both;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999 !important;
  }

  .modal-wrapper {
      position: fixed;
      animation: FADE_IN_TOP 0.24s 0.24s ease-out both;
  }

  [id^="header_"] {
    position: sticky;
    top: 0;
    z-index: 10000;

    @media (min-width: ${mobileBreakPointCSS}) {
      position: relative;
    }
  }
`;

export const Wrapper: React.FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  //@TODO: Replace with proper theme when ready
  //<ThemeProvider theme={storeContext.data.themeSettings}>

  return (
    <ThemeProvider theme={defaultTheme}>
      <ModalProvider>
        <GlobalStyle />
        {children}
      </ModalProvider>
    </ThemeProvider>
  );
};
